import { PromoCategoryHelper } from "app/helpers/promoCategoryHelper";
import { RowHeightHelper } from "app/helpers/rowHeightHelper";
import { PromoType } from "app/types/promoType";
import cx from "classnames";
import React, { Component, lazy, Suspense } from "react";
import { FormattedMessage } from "react-intl";
import Media from "react-media";
import { connect } from "react-redux";
import { VariableSizeList as List } from "react-window";
import { $Values } from "utility-types";
import * as summaryApi from "../../../../api/summaryApi";
import BetDrawerButton from "../../../../components/BetDrawerButton/BetDrawerButton";
import { IconEmptyFavorite } from "../../../../components/Icon/Icon";
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";
import ScrollToTop from "../../../../components/ScrollToTop/ScrollToTop";
import SummaryLogic from "../../../../logic/summaryLogic";
import type { CompetitionType } from "../../../../types/competitionType";
import type { RouterMatchType } from "../../../../types/types";
import type { UserType } from "../../../../types/userType";
import {
  competitionListTimeEnum,
  ListRenderValues,
  ResponsiveScreenSizes,
  TabTypes,
} from "../../../../utils/const";
import CompetitionCellMobile from "../../components/CompetitionCellMobile/CompetitionCellMobile";
import "./CompetitionsScreenMobile.scss";
const EventsScreenHeader: React.LazyExoticComponent<any> = lazy(
  () => import("../../components/EventsScreenHeader/EventsScreenHeader")
);
const EventsScreenTimeFilter: React.LazyExoticComponent<any> = lazy(
  () => import("../../components/EventsScreenTimeFilter/EventsScreenTimeFilter")
);
//
type Props = {
  match: RouterMatchType;
  competitionList: CompetitionType[];
  competitionListTotal: number;
  competitionListOffset: number;
  competitionListReachedEnd: boolean;
  isCompetitionListLoading: boolean;
  setCompetitionListLoading: boolean;
  competitionListNumberLiveEvents: number;
  setSingleCompetition: (...args: Array<any>) => any;
  resetCompetitions: (...args: Array<any>) => any;
  resetFiltering: (...args: Array<any>) => any;
  filterNavNodeIds: string;
  isIdle: boolean;
  user: UserType;
  isUserLoading: boolean;
  selectedCompetitionType: $Values<typeof TabTypes>;
  updateCompetitionListType: (...args: Array<any>) => any;
  updateCompetitionListTime: (...args: Array<any>) => any;
  setBookmarksOnly: (...args: Array<any>) => any;
  loadFavouritesCount: (...args: Array<any>) => any;
  disableFilterTab: boolean;
  disableFilter: (...args: Array<any>) => any;
  disableTodayEarlyFilter: (...args: Array<any>) => any;
  bookmarksTotal: number;
  setCompetitionWithFavouritesList: (...args: Array<any>) => any;
  setFavouritesOnly: (...args: Array<any>) => any;
  currentFavouritesCount: number;
  navigationMenuOpen: boolean;
  checkIfMenuOpen: (...args: Array<any>) => any;
  loadFavourites: (...args: Array<any>) => any;
  setFutures: Function;
  favouritesOnly: boolean;
  bookmarksOnly: boolean;
  singleCompetitionOnly: boolean;
  time: string;
  history: any;
  isPageVisible: boolean;
  fullListLoaded: boolean;
  futures: boolean;
  promoCategory: PromoType;
};
type State = {
  time: any;
  favouritesActive: boolean;
};

class CompetitionsScreenMobile extends Component<Props, State> {
  list: any;
  accountStatsIntervalId: any;
  isUserLoaded: boolean;
  constructor(props: Props) {
    super(props);
    this.state = {
      time: this.props.time,
      favouritesActive: this.props.favouritesOnly,
    };
    this.list = React.createRef();
    this.isUserLoaded = false;
    this.props.loadFavouritesCount();
    this.startAccountStatsInterval();
  }

  componentDidUpdate(prevProps) {
    const { promoCategory, favouritesOnly } = this.props;
    // If the competition list has been updated with new items
    // which means that the loading is done
    // if promoted event load select event
    if (promoCategory.isPromoted) {
      PromoCategoryHelper.updatePromotedCategories(
        promoCategory,
        this.props,
        prevProps,
        true
      );
    }

    if (
      !this.props.isCompetitionListLoading &&
      prevProps.isCompetitionListLoading
    ) {
      // Then clear the calculated height of the list
      this.resizeCell(0);
    }

    // Clear cache of list if any events in a competition has been removed
    // First check if the competition list had items in it before the update
    if (
      prevProps.competitionList != null &&
      prevProps.competitionList.length > 0
    ) {
      prevProps.competitionList.every(prevCompetition => {
        // find the same competition in current list of competitions
        const newCompetitionIndex = this.props.competitionList.findIndex(
          competition => competition.id === prevCompetition.id
        );
        const newCompetition = this.props.competitionList[newCompetitionIndex];

        // if same competition is found
        // and its number of shown events (not the total number of events)
        // is different from the previous competition
        if (
          newCompetition != null &&
          newCompetition.events.length !== prevCompetition.events.length
        ) {
          // then clear calculated height of the competition cell
          setTimeout(() => {
            this.resizeCell(newCompetitionIndex);
          }, 0);
          return false; // break loop
        }

        return true; // continue loop
      });
    }
  }

  componentWillUnmount() {
    this.props.resetCompetitions();
    this.clearAccountStatsInterval();
  }
  handleChangeListTime = time => {
    this.setState({
      time: time,
    });
    // if previos collectionlist exist reset
    if (this.props.competitionList.length > 0) this.props.resetCompetitions();
    this.props.updateCompetitionListTime(time);
  };
  handleChangeListType = typeChange => {
    // update store competition type with change
    this.props.updateCompetitionListType(typeChange);
    // if previos collectionlist exist reset
    if (this.props.competitionList.length > 0)
      this.props.resetCompetitions(typeChange);
    // get new compeitionsList
  };

  startAccountStatsInterval() {
    this.accountStatsIntervalId = setInterval(() => {
      if (!this.props.isIdle) {
        summaryApi.fetchSummary().then(resp => {
          SummaryLogic.updateSummary(resp.accountStats);
        });
      }
    }, 20000);
  }

  clearAccountStatsInterval() {
    clearInterval(this.accountStatsIntervalId);
  }

  calculateListHeight = () => {
    let height = 1000;
    let headerHeight = 220;
    if (this.props.favouritesOnly || this.props.bookmarksOnly) {
      headerHeight = 154;
    } else if (this.props.selectedCompetitionType === TabTypes.ALL) {
      headerHeight = 234;
    }
    if (window.innerHeight > 200) {
      height = window.innerHeight - headerHeight;
    }
    return height;
  };
  renderEndOfList = () => {
    return (
      <div className="competitions-screen-mobile__list__end-of-list">
        {this.props.fullListLoaded ||
        this.props.competitionList.length < ListRenderValues.THRESHOLD ? (
          <FormattedMessage tagName="span" id="events-nomore" />
        ) : (
          <LoadingSpinner />
        )}
      </div>
    );
  };
  rowRenderer = ({ index, style }) => {
    let content;
    const competition: CompetitionType = this.props.competitionList[index];

    if (competition != null) {
      content = (
        <CompetitionCellMobile
          data={competition}
          resizeCell={this.resizeCell}
          competitionIndex={index}
          key={competition.id}
          setCompetitionWithFavouritesList={
            this.props.setCompetitionWithFavouritesList
          }
        />
      );
    } else {
      // this is used as a placeholder for the very last item
      // in the list to add some bottom "padding"
      content = (
        <React.Fragment>
          <div className="competitions-screen-mobile__list__bottom-spacer" />
          {this.props.competitionList.length > 0 && this.renderEndOfList()}
        </React.Fragment>
      );
    }

    return (
      <div key={index} style={style} onClick={() => this.onRowClick(index)}>
        {content}
      </div>
    );
  };
  onRowClick = (index: number) => {
    // clear calculation of heights
    // to perform recalculation of new heights
    this.resizeCell(index);
  };

  onClickFutures = (futures: boolean) => {
    if (futures) {
      this.props.history.push("/futures/");
    } else {
      this.props.history.goBack();
    }
  };

  onClickBookmarks = () => {
    if (!this.props.bookmarksOnly) {
      this.props.history.push("/bookmarks/");
    } else {
      this.props.history.goBack();
    }
  };
  resetFiltering = () => {
    this.props.resetFiltering();
    this.props.disableFilter(false);
    this.props.disableTodayEarlyFilter(false);
  };
  onClickFavourites = () => {
    this.setState({
      favouritesActive: !this.props.favouritesOnly,
    });
    if (this.props.favouritesOnly) {
      this.props.history.goBack();
    } else {
      this.props.history.push("/favourites/");
    }
  };
  // clear the cache of the cell and the list
  resizeCell = (index: number) => {
    if (this.list && this.list.current) {
      this.list.current.resetAfterIndex(index);
    }
  };

  checkClickEvent = (e: any) => {
    if (this.props.navigationMenuOpen) {
      this.props.checkIfMenuOpen(false);
    }
  };
  getNoEventsContent = () => {
    const {
      selectedCompetitionType,
      bookmarksTotal,
      bookmarksOnly,
      favouritesOnly,
    } = this.props;
    let message = (
      <FormattedMessage tagName="span" id="events-no-active-events" />
    );

    // no live events
    if (
      !favouritesOnly &&
      !bookmarksOnly &&
      selectedCompetitionType === TabTypes.LIVE
    ) {
      message = <FormattedMessage tagName="span" id="events-no-live-events" />; // No events today
    } else if (
      !favouritesOnly &&
      !bookmarksOnly &&
      this.state.time === competitionListTimeEnum.TODAY &&
      selectedCompetitionType === TabTypes.ALL
    ) {
      message = <FormattedMessage tagName="span" id="events-no-events-today" />; // No active events
    } else if (
      !favouritesOnly &&
      !bookmarksOnly &&
      this.state.time === competitionListTimeEnum.EARLY &&
      selectedCompetitionType === TabTypes.ALL
    ) {
      message = (
        <FormattedMessage tagName="span" id="events-no-active-events" />
      ); // no event for next 24 hours
    } else if (
      !favouritesOnly &&
      !bookmarksOnly &&
      selectedCompetitionType === TabTypes.POPULAR
    ) {
      message = (
        <FormattedMessage tagName="span" id="events-no-events-24-hours" />
      ); // no favourites
    } else if (!bookmarksOnly && favouritesOnly) {
      message = (
        <div className="empty-list__message">
          <div className="favourites-image">
            <IconEmptyFavorite />
          </div>
          <FormattedMessage tagName="span" id="favourites-no-events" />
        </div>
      ); // no bookmarked leagues have events
    } else if (!favouritesOnly && bookmarksOnly && bookmarksTotal !== 0) {
      message = (
        <FormattedMessage tagName="span" id="events-no-active-events" />
      ); // no  leagues bookmarked
    } else if (!favouritesOnly && bookmarksOnly && bookmarksTotal === 0) {
      message = <FormattedMessage tagName="span" id="events-no-bookmarks" />;
    }

    //
    return (
      <div className="competitions-screen-mobile__list__empty-list">
        {message}
      </div>
    );
  };
  componentDidMount = () => {
    const {
      competitionList,

      isCompetitionListLoading,
      competitionListReachedEnd,
      favouritesOnly,
    } = this.props;

    // BET-5560 extra call to ensure competition lists loaded
    // when navigating back to events view
    if (
      competitionList.length === 0 &&
      !isCompetitionListLoading &&
      competitionListReachedEnd &&
      !favouritesOnly
    ) {
      // setCompetitions();
    }
  };

  render() {
    const {
      selectedCompetitionType,
      disableFilterTab,
      competitionList,
      competitionListNumberLiveEvents,
      isCompetitionListLoading,
      favouritesOnly,
      bookmarksOnly,
      history,
      singleCompetitionOnly,
      futures,
    } = this.props;
    const listCount = this.props.competitionList.length + 1;
    let content = <div />;

    // Check that there is a list to display, otherwise show blank state message
    if (competitionList.length === 0 && !isCompetitionListLoading) {
      content = this.getNoEventsContent();
    } else {
      if (competitionList.length === 0) {
        // list is still loading so show loading spinner
        content = (
          <div className="competitions-screen-mobile__loading">
            <LoadingSpinner />
          </div>
        );
      } else {
        content = (
          <div
            className={cx(
              "competitions-screen-mobile__wrapper",
              {
                "competitions-screen-mobile__wrapper--filter-active":
                  bookmarksOnly || favouritesOnly,
              },
              {
                "competitions-screen-mobile__wrapper--all-active":
                  !bookmarksOnly &&
                  !favouritesOnly &&
                  selectedCompetitionType === TabTypes.ALL,
              },
              {
                "single-event-competition":
                  singleCompetitionOnly &&
                  selectedCompetitionType === TabTypes.ALL,
              }
            )}
            onClick={() => this.checkClickEvent()}
          >
            <List
              ref={this.list}
              className="List"
              itemCount={listCount}
              height={this.calculateListHeight()}
              itemSize={RowHeightHelper.calculateMobileRowHeight}
              itemData={this.props.competitionList}
            >
              {this.rowRenderer}
            </List>
          </div>
        );
      }
    }

    return (
      <div className="competitions-screen-mobile">
        <Suspense fallback={<div className="fallback">loading...</div>}>
          <EventsScreenHeader
            competitionListNumberLiveEvents={competitionListNumberLiveEvents}
            callback={this.handleChangeListType}
            onClickBookmarks={this.onClickBookmarks}
            onClickFavourites={this.onClickFavourites}
            onClickFutures={this.onClickFutures}
            bookmarksActive={this.props.bookmarksOnly}
            type={selectedCompetitionType}
            disableFilterTab={disableFilterTab}
            currentFavouritesCount={this.props.currentFavouritesCount}
            isCompetitionListLoading={this.props.isCompetitionListLoading}
            favouritesActive={this.state.favouritesActive}
            checkClickEvent={this.checkClickEvent}
            history={history}
          />
        </Suspense>
        {!futures &&
          !favouritesOnly &&
          !bookmarksOnly &&
          selectedCompetitionType === TabTypes.ALL && (
            <Suspense fallback={<div className="fallback">loading...</div>}>
              <EventsScreenTimeFilter
                time={this.state.time}
                callback={this.handleChangeListTime}
                favouritesActive={this.state.favouritesActive}
                selectedCompetitionType={selectedCompetitionType.toLowerCase()}
              />
            </Suspense>
          )}
        {content}
        {/* mobile only components */}
        <Media
          query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
          render={() => (
            <div>
              <ScrollToTop />
              <BetDrawerButton />
            </div>
          )}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  competitionList: state.competitionListModel.competitionList,
  competitionListTotal: state.competitionListModel.competitionListTotal,
  competitionListOffset: state.competitionListModel.competitionListOffset,
  competitionListReachedEnd:
    state.competitionListModel.hasCompetitionListReachedEnd,
  isCompetitionListLoading: state.competitionListModel.isCompetitionListLoading,
  setCompetitionListLoading:
    state.competitionListModel.setCompetitionListLoading,
  competitionListNumberLiveEvents:
    state.competitionListModel.competitionListNumberLiveEvents,
  filterNavNodeIds: state.navigationModel.filterNavNodeIds,
  user: state.userModel.user,
  isUserLoading: state.userModel.isUserLoading,
  selectedCompetitionType: state.competitionsListFiltersModel.type,
  time: state.competitionsListFiltersModel.time,
  disableFilterTab: state.competitionListModel.disableFilterTab,
  bookmarksTotal: state.bookmarkListModel.total,
  currentFavouritesCount: state.favouritesListModel.currentFavouritesCount,
  navigationMenuOpen: state.navigationModel.navigationMenuOpen,
  favouritesOnly: state.competitionListModel.favouritesOnly,
  bookmarksOnly: state.competitionsListFiltersModel.bookmarksOnly,
  singleCompetitionOnly: state.competitionListModel.singleCompetitionOnly,
  isIdle: state.sessionModel.isIdle,
  isPageVisible: state.sessionModel.isPageVisible,
  fullListLoaded: state.competitionListModel.fullListLoaded,
  futures: state.competitionListModel.futures,
  promoCategory: state.promoCategoryModel,
});

const mapDispatchToProps = (dispatch: any) => ({
  setSingleCompetition: () => {
    dispatch.competitionListModel.setSingleCompetitionList();
  },
  loadFavourites: callback => {
    dispatch.favouritesListModel.setFavouriteList({
      callback,
    });
  },
  resetCompetitions: () => {
    dispatch.competitionListModel.resetCompetition();
  },
  resetFiltering: () => {
    dispatch.navigationModel.resetFiltering();
  },
  updateCompetitionListType: (type: string) => {
    dispatch.competitionsListFiltersModel.updateCompetitionListType(type);
  },
  updateCompetitionListTime: time => {
    dispatch.competitionsListFiltersModel.updateCompetitionListTime(time);
  },
  setBookmarksOnly: (bookmarksOnly: boolean) => {
    dispatch.competitionsListFiltersModel.setBookmarksOnly(bookmarksOnly);
  },
  setFavouritesOnly: (favouritesOnly: boolean) => {
    dispatch.competitionListModel.setFavouritesOnly(favouritesOnly);
  },
  loadFavouritesCount: () => {
    dispatch.favouritesListModel.getFavouriteListCount();
  },
  disableFilter: disable => {
    dispatch.competitionListModel.disableFilter(disable);
  },
  setCompetitionWithFavouritesList: callback => {
    dispatch.competitionListModel.setCompetitionWithFavouritesList(callback);
  },
  checkIfMenuOpen: value => dispatch.navigationModel.checkIfMenuOpen(value),
  disableTodayEarlyFilter: disable => {
    dispatch.competitionListModel.disableTodayEarlyFilter(disable);
  },
  setFutures: (futures: boolean) => {
    dispatch.competitionListModel.setFutures(futures);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompetitionsScreenMobile) as any;
